import script from "./AddUsersAndGroupFieldGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUsersAndGroupFieldGroup.vue?vue&type=script&setup=true&lang=js"

import "./AddUsersAndGroupFieldGroup.vue?vue&type=style&index=0&id=219bcf7d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-219bcf7d"]])

export default __exports__